import type { SourceProducts } from '@atlassian/conversation-assistant-instrumentation/types/analytics';
import { type Sources } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const constructSourceProducts = (sources: Sources | undefined): SourceProducts => {
	if (!sources) {
		return {};
	}

	const products: SourceProducts = {};
	sources.forEach((source) => {
		const productName = source.product;
		if (productName) {
			products[productName] = (products[productName] ?? 0) + 1;
		}
	});

	return products;
};
